import React from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { YellowWarning } from '../../../assets/SvgIcons';
import { CustomeModalButton } from '../../../lib/formik/NewFormInputs';

type Props = {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    title?: string,
    desc?: string,
    setOpenBankModal?: React.Dispatch<React.SetStateAction<boolean>>,
    // setActiveTab?: React.Dispatch<React.SetStateAction<string>>
    handleClose?: () => void
    handleConfirm?: () => void
    confirmBtnText?: string
}


function AlertModel(props: Props) {
    const { open, setOpen, title, desc, setOpenBankModal, handleClose, handleConfirm, confirmBtnText } = props

    const handleSubmit = () => {
        setOpen(false)
        setOpenBankModal && setOpenBankModal(true)
    }


    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby={title}
            aria-describedby={desc}
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: { lg: '500px', md: '500px', sm: '300px', xs: '300px' },
                width: '100%',
                bgcolor: 'background.paper',
                borderRadius: { xs: '15px', sm: '15px', md: '0px', lg: '0px' },
                boxShadow: 24,
                p: '24px',
                ':focus': {
                    outline: 'none'
                }
            }}>
                <Box display={'flex'} alignItems={'center'} gap={'12px'}>
                    <YellowWarning />
                    <Typography id={title} variant="h2" fontSize={{ lg: '20px', md: '20px', sm: '16px', xs: '16px' }}>
                        {title}
                    </Typography>
                </Box>
                <Typography id="modal-modal-description" sx={{ mt: 2, maxWidth: '400px', width: '100%' }} fontSize={{ lg: '16px', md: '16px', sm: '14px', xs: '14px' }}>
                    {desc}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '12px', marginTop: { lg: '48px', md: '48px', sm: '30px', xs: '30px' } }}>
                    <CustomeModalButton onClick={handleClose} lookType={'outlined'} btnText={'Cancel'} />
                    <CustomeModalButton onClick={() => handleConfirm ? handleConfirm() : handleSubmit()} lookType={'contained'} btnText={confirmBtnText || 'Create Mandate'} />
                </Box>
            </Box>
        </Modal>

    )
}

export default AlertModel